import { svgSectionCtrl } from './svg.section.controller';
import template from './svg.section.html';

export const svgSection: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: svgSectionCtrl,
  controllerAs: 'vm',
  template,
  link(scope, element, attrs, vm) {
    vm!.$el = element;

    element.addClass('svg-section');
  },
  restrict: 'A',
  scope: {
    sectionId: '@',
    houseId: '@?',
    imageUrl: '@',
    svgUrl: '@',
    notifyErrors: '=?',
    publicMode: '=?',
  },
});
